// @flow
import {useEffect, useState} from 'react';
import {getDeliveryMethodsApi} from '../api';
import {useSelector} from 'react-redux';
import type {RootState} from '../..';
import {useShippingMethodConfig} from '.';

import type {DeliveryMethod} from '../../../entities/logistic/delivery-method';

const storeSelector = (state: RootState) => state.store.store?.id;

export function useShippingMethod(
  countryCode?: string,
  admin1Id?: number,
  admin2Id?: number,
  admin3Id?: number
) {
  const [shippingMethods, setShippingMethods] = useState<DeliveryMethod[]>([]);
  const [loading, setIsLoading] = useState(false);
  const storeId = useSelector(storeSelector);
  const {shippingMethod} = useShippingMethodConfig();
  const shippingMethodType = shippingMethod.storeShippingMethodType;

  useEffect(() => {
    setIsLoading(true);
    getDeliveryMethodsApi({
      delivery_method: 'SHIPPING',
      shipping_method_type: shippingMethodType,
      country: countryCode,
      store_id: storeId,
      admin1_id: admin1Id,
      admin2_id: admin2Id,
      admin3_id: admin3Id,
    })
      .toPromise()
      .then(methods => {
        setShippingMethods(methods?.filter(method => method.enabled));
      })
      .catch(error => {
        console.log(error);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [admin1Id, admin2Id, admin3Id, countryCode, shippingMethodType, storeId]);

  return {
    shippingMethods,
    isLoading: loading,
    shippingMethodType,
  };
}
